<h2 mat-dialog-title>
  <ng-container *ngIf="helpType === 'reference'">Reference Number Help</ng-container>
  <ng-container *ngIf="helpType === 'reports'">Report Options</ng-container>
  <ng-container *ngIf="helpType === 'parties'">Shipper, Consignee &amp; Bill To Party Help</ng-container>
</h2>

<mat-dialog-content>
  <div *ngIf="helpType === 'reference'">
    <p>You can limit your results based on reference numbers found in EDI messages.</p>

    <p>To add a reference number, click the <mat-icon class="md-primary">add_circle</mat-icon> icon, then enter a reference type code, a reference number, or both.</p>

    <p>You can add as many reference type and reference number searches as you want. Click the <mat-icon class="md-primary">add_circle</mat-icon> icon to add additional Type and Reference Number fields.</p>

    <h3>Options for Entering Reference Types and Numbers</h3>
    <p>You can enter reference types and numbers in a variety of ways for different results.</p>

    <table class="criteria-help-table">
      <tr>
        <th>If you enter:</th>
        <th>Search results will show:</th>
      </tr>
      <tr>
        <td>Only a reference type code (and no reference number)</td>
        <td>All EDI messages which contain that reference type code</td>
      </tr>
      <tr>
        <td>Only a reference number (and no reference type)</td>
        <td>All EDI messages which contain that reference number in any reference number segment</td>
      </tr>
      <tr>
        <td>Both the reference type and reference number</td>
        <td>Only EDI messages which contain that reference type <em>and</em> that reference number</td>
      </tr>
      <tr>
        <td>Multiple reference numbers</td>
        <td>Only EDI messages which contain all reference numbers you entered.
          Example: You enter reference numbers "123" and "456". Results are limited to messages which contain both.</td>
      </tr>
      <tr>
        <td>Multiple reference types for a single reference number</td>
        <td>All EDI messages which have that reference number and <em>either</em> reference type.</td>
      </tr>
    </table>

    <h3>Wildcards</h3>
    <p>The Type and Reference Number fields accept asterisks (*) and question marks (?).</p>
    <ul>
      <li>Use an <strong>asterisk (*)</strong> to replace one or more missing characters.</li>
      <li>Use a <strong>question mark (?)</strong> to replace a single character.</li>
    </ul>

    <h3>Segments Search to Find Reference Types and Numbers</h3>
    <table class="criteria-help-table">
      <tr>
        <th>Segment</th>
        <th>Search Tool looks at this ELEMENT for the Reference TYPE</th>
        <th>Search Tool looks at this ELEMENT for the Reference NUMBER</th>
      </tr>
      <tr><td>L11</td><td>L1102</td><td>L1101</td></tr>
      <tr><td>N9</td><td>N901</td><td>N902</td></tr>
      <tr><td>MAN</td><td>MAN01</td><td>MAN02</td></tr>
    </table>

    <h3>Additional Places Searched to Find Reference Types</h3>
    <table class="criteria-help-table">
      <tr>
        <th>Reference Type</th>
        <th>What is searched</th>
      </tr>
      <tr><td>PRO</td><td>XPO PROs on shipment statuses or invoices (214 or 210).</td></tr>
      <tr><td>SN#</td><td>EDI senders' shipment IDs on pickup requests and bills of lading (204 and 211).</td></tr>
      <tr><td>BATCH#</td><td>Group control numbers on acknowledgements (997).</td></tr>
      <tr><td>PO#</td><td>Shipment purchase order numbers in the SPO and OID segments.</td></tr>
    </table>
  </div>

  <div *ngIf="helpType === 'reports'">
    <p>Depending on Transaction Type, you can search by Pro Number, Shipment ID, or Reference Number.</p>

    <table class="criteria-help-table">
      <tr>
        <th>Transaction Type</th>
        <th>ID Type</th>
        <th>Segments Searched</th>
      </tr>
      <tr><td>Invoice</td><td>Pro Number</td><td>B302</td></tr>
      <tr><td>Pickup/BOL</td><td>Shipment ID</td><td>B204, BOL03</td></tr>
      <tr><td>Pickup/BOL</td><td>Ref</td><td>LL1101, and optional 'Reference Code' LL1102</td></tr>
      <tr><td>Shipment Status</td><td>Pro Number</td><td>B1001</td></tr>
      <tr><td>Shipment Status</td><td>Ref</td><td>LL1101, and optional 'Reference Code' LL1102</td></tr>
      <tr><td>Shipment Status</td><td>Shipment ID</td><td>B1002</td></tr>
    </table>

    <h3>Partial Match</h3>
    <p>If Partial Match is selected, a wildcard will be applied to each ID.</p>

    <h3>Reference Code</h3>
    <p>Reference Code allows you to search for a particular reference code in a reference number block.</p>
  </div>

  <div *ngIf="helpType === 'parties'">
    <p>Entering information in <strong>Shipper</strong>, <strong>Consignee</strong> or <strong>Bill To</strong> fields causes the Search Tool to look at the N1, N2, N3, and N4 segments within EDI messages.</p>

    <table class="criteria-help-table">
      <tr>
        <th>Information entered in this FIELD</th>
        <th>Causes the Search Tool to look at these ELEMENTS</th>
      </tr>
      <tr><td>Name 1</td><td>N102</td></tr>
      <tr><td>Name 2</td><td>N201 and N202</td></tr>
      <tr><td>Location ID</td><td>N104</td></tr>
      <tr><td>Address</td><td>N301 and N302</td></tr>
      <tr><td>City</td><td>N401</td></tr>
      <tr><td>State code</td><td>N402</td></tr>
      <tr><td>Postal code</td><td>N403</td></tr>
      <tr><td>Country code</td><td>N404</td></tr>
    </table>

    <p>If searching for <strong>inbound</strong> EDI messages, the party information is provided by the <strong>partner</strong>.</p>
    <p>If searching for <strong>outbound</strong> EDI messages, party information typically comes from <strong>CIS</strong>.</p>

    <h3>Wildcards</h3>
    <p>All fields in this section accept asterisks (*) and question marks (?) as wildcards.</p>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button (click)="close()">Close</button>
</mat-dialog-actions>
